import React from 'react';
import { SampleType, SampleProcessingStatus } from '@models';

type SampleTypeContentProps = {
  sampleType: SampleType;
  warning: {
    status: SampleProcessingStatus;
    message: string;
  };
};

const SampleTypeContent: React.VFC<SampleTypeContentProps> = ({
  sampleType,
  warning: { status, message },
}) => {
  return (
    <>
      <div>{sampleType}</div>
      {status === 'ProcessingWithWarning' ? <div>{message}</div> : <></>}
    </>
  );
};

export default SampleTypeContent;
